import { styled } from '@mui/material/styles';

import { LARGE_VIEW_PORT_VALUE_WIDTH } from '../../../models/dimensions.model';
import { Chip } from '../../../ui-kit/chip/chip.component';
import { shouldForwardProps } from '../../../utils/mui-styled.utils';

interface TextRenderStyledProps {
	isUserMessage: boolean;
}
export const StyledTextRenderWrapper = styled('div', {
	shouldForwardProp: shouldForwardProps(['isUserMessage']),
})<TextRenderStyledProps>(
	({
		theme: {
			palette: { sizes },
		},
		isUserMessage,
	}) => ({
		display: 'flex',
		padding: `1px ${sizes.size_1}%`,
		...(isUserMessage
			? { justifyContent: 'flex-end', paddingTop: 0, paddingBottom: 0 }
			: {
					justifyContent: 'flex-start',
					padding: `0 ${sizes.size_1}%`,
					[`@media (min-width:${LARGE_VIEW_PORT_VALUE_WIDTH}px)`]: {
						minWidth: `calc(${LARGE_VIEW_PORT_VALUE_WIDTH}px - ${sizes.size_1})`,
						width: '85%',
						paddingRight: 0,
					},
				}),
	}),
);

export const StyledTextRenderMessageContainer = styled('div', {
	shouldForwardProp: shouldForwardProps(['isUserMessage']),
})<TextRenderStyledProps>(
	({
		theme: {
			palette: { sizes, colorScheme },
			typography: { smallViewPort, largeViewPort },
		},
		isUserMessage,
	}) => ({
		fontSize: 17,
		overflowWrap: 'anywhere',
		whiteSpace: 'pre-line',
		height: 'auto',
		...(isUserMessage
			? {
					maxWidth: '100%',
					display: 'flex',
					justifyContent: 'flex-end',
				}
			: {
					padding: `0 ${sizes.size_1}px`,
					...smallViewPort.typeBot1,
					[`@media (min-width:${LARGE_VIEW_PORT_VALUE_WIDTH}px)`]: {
						...largeViewPort.typeBot1,
					},
					...colorScheme.customStyle.botMessages,
				}),
	}),
);

export const StyledTextRenderedChip = styled(Chip)(
	({
		theme: {
			palette: { colorScheme },
		},
	}) => ({
		...colorScheme.customStyle.userMessage,
	}),
);
